import { Component, HostBinding, Input, OnInit } from '@angular/core'

@Component({
  selector: 'app-lead-app-footer',
  templateUrl: './lead-app-footer.component.html',
  styleUrls: ['./lead-app-footer.component.scss'],
})
export class LeadAppFooterComponent implements OnInit {
  @HostBinding('style.display') hostDisplay = 'flex'
  @Input() path = ''
  @Input() buttonText = '타입스 앱에서 열기'

  constructor() {}

  ngOnInit(): void {}

  close(): void {
    this.hostDisplay = 'none'
  }
}
